import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-53135bc8"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  for: "address",
  class: "input-label"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "ETH address (optional)", -1))
const _hoisted_3 = { class: "input-container" }
const _hoisted_4 = {
  key: 0,
  class: "resolved-address"
}
const _hoisted_5 = {
  key: 0,
  class: "error-message"
}

import { isAddress } from '@ethersproject/address';
import { onMounted, ref, watch } from 'vue';
import Tooltip from '@/components/Tooltip.vue';
import { formatAddress, resolveEnsName } from '@/lib/address';


export default /*#__PURE__*/_defineComponent({
  __name: 'RecipientAddressInput',
  emits: ['onAddressChanged'],
  setup(__props, { emit }) {

const inputValue = ref('');
const error = ref('');
const resolvedAddress = ref('');
const isEnsAddress = ref(false);
const isLoading = ref(false);

const isValidEns = (ens: string) => /^[a-zA-Z0-9-]+\.eth$/.test(ens);

onMounted(() => {
  // inputValue.value = tryGetLocalStorage(CROSSMINT_MINTFOR_LOCAL_STORAGE_KEY);
});

const processInput = async () => {
  isLoading.value = true;
  error.value = '';
  resolvedAddress.value = '';
  isEnsAddress.value = false;

  if (!inputValue.value) return;

  resolvedAddress.value = inputValue.value;

  if (!isAddress(inputValue.value)) {
    if (isValidEns(inputValue.value)) {
      const address = await resolveEnsName(inputValue.value);

      if (address) {
        resolvedAddress.value = address;
        isEnsAddress.value = true;
      } else {
        error.value = 'ENS domain does not resolve to an address';
      }
    } else {
      error.value = 'Invalid Ethereum address or ENS domain';
    }
  }

  isLoading.value = false;
};



watch(resolvedAddress, (value) => {
  emit('onAddressChanged', value);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("label", _hoisted_1, [
      _hoisted_2,
      _createVNode(Tooltip, {
        header: "Recipient ETH Address",
        content: "You can optionally provide an Ethereum wallet address where the item will be sent to directly."
      })
    ]),
    _createElementVNode("div", _hoisted_3, [
      _withDirectives(_createElementVNode("input", {
        onFocusout: processInput,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((inputValue).value = $event)),
        onInput: processInput,
        class: _normalizeClass(['text-input', error.value ? 'error' : '', isEnsAddress.value ? 'has-resolved-address' : '']),
        name: "address",
        type: "text",
        placeholder: "example.eth"
      }, null, 34), [
        [_vModelText, inputValue.value]
      ]),
      (isEnsAddress.value)
        ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_unref(formatAddress)(resolvedAddress.value)), 1))
        : _createCommentVNode("", true)
    ]),
    (error.value)
      ? (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(error.value), 1))
      : _createCommentVNode("", true)
  ]))
}
}

})